/**
 * Mutación que guarda en el estado la información del evento para mostrarse en el checkout
 * @param {State} state Estado de Vue
 * @param {Object} checkoutInformation Objecto que guarda la información del evento
 */
export function setCheckoutInformation(state, checkoutInformation) {
    state.checkoutInformation = checkoutInformation
}

/**
 * 
 * @param {State} state 
 * @param {Object} cardPaymentInformation Objecto de la Información de la tarjeta
 */
export function setCardPaymentInformation(state, cardPaymentInformation) {
    state.cardPaymentInformation = cardPaymentInformation
}

/**
 * Mutación que limpia la información del evento en el checkout
 * @param {State} state Estado de Vue
 */
export function clearCheckoutInformation(state) {
    state.checkoutInformation = {}
}